import type { SelectProps } from '@mui/material/Select';
import type { CapTableDetailsModel } from 'api/models/CapTableDetailsModel';
import type { CapTableModel } from 'api/models/CapTableModel';

// This Select can accept either model without using either enum as the prop type
// (those enums are nominal and not interchangeable). The intersection fails to compile
// if the two generated value sets ever diverge.
export type AccessLevelValue = `${CapTableModel.access_level}` & `${CapTableDetailsModel.access_level}`;

export interface AccessLevelOption {
  description: string;
  label: string;
  value: AccessLevelValue;
}

const ACCESS_LEVEL_OPTION_COPY: Record<AccessLevelValue, Omit<AccessLevelOption, 'value'>> = {
  collaborative: {
    description: 'Everyone can edit, including Full Access Viewers.',
    label: 'Collaborative',
  },
  restricted: {
    description: 'Everyone can view. Only Analysts can edit.',
    label: 'Restricted',
  },
  private: {
    description: 'Only you can access this version.',
    label: 'Private',
  },
};

// Shared options for the create and edit dialogs
export const ACCESS_LEVEL_OPTIONS: AccessLevelOption[] = (
  Object.keys(ACCESS_LEVEL_OPTION_COPY) as AccessLevelValue[]
).map(value => ({
  value,
  ...ACCESS_LEVEL_OPTION_COPY[value],
}));

export interface AccessLevelSelectProps
  extends Omit<SelectProps<AccessLevelValue>, 'IconComponent' | 'onChange' | 'renderValue' | 'value'> {
  onChange: (value: AccessLevelValue) => void;
  value: AccessLevelValue;
}
